import script from "./enrolledStudents.vue?vue&type=script&setup=true&lang=js"
export * from "./enrolledStudents.vue?vue&type=script&setup=true&lang=js"

import "./enrolledStudents.vue?vue&type=style&index=0&id=4c441988&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c441988"]])

export default __exports__